import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Welcome from "@/pages/Welcome";
import UserInfo from "@/pages/UserInfo";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import { AssessmentProvider } from "@/context/AssessmentContext";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App grain-bg">
      <AssessmentProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/info" element={<UserInfo />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/risultati" element={<Results />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AssessmentProvider>
    </div>
  );
}

export default App;
